import React, { useState, useEffect, useCallback } from 'react';

import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';

import { stringifySearch } from '@src/utils/urlHelpers';

import Layout from './FindGuidelinesLayout';

import './FindGuidelines.scss';

const FindGuidelines = ({ product }) => {
    const navigate = useNavigate();

    const [selectedResource, setSelectedResource] = useState(null);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(product);

    // Sync product prop changes to selectedProduct state
    useEffect(() => {
        setSelectedProduct(product);
    }, [product]);

    const handleResourceSelect = useCallback((selection) => {
        setSelectedResource(selection);
    }, []);

    const handleStateSelect = useCallback((selection) => {
        setSelectedState(selection);
    }, []);

    const handleProductSelect = useCallback((selection) => {
        setSelectedProduct(selection);
    }, []);

    const handleGoClick = useCallback(() => {
        const params = {};

        if (selectedResource) {
            params['resource_type'] = selectedResource;
        }

        if (selectedState) {
            params['state_id'] = selectedState;
        }

        if (selectedProduct) {
            params['product_id'] = selectedProduct;
        }

        const search = stringifySearch(params);

        navigate({ pathname: '/guides-and-rate-bulletins', search });
    }, [navigate, selectedResource, selectedState, selectedProduct]);

    return (
        <Layout
            selectedResource={selectedResource}
            selectedState={selectedState}
            selectedProduct={selectedProduct}
            showProduct={!product}
            onResourceSelect={handleResourceSelect}
            onStateSelect={handleStateSelect}
            onProductSelect={handleProductSelect}
            onGoClick={handleGoClick}
        />
    );
};

FindGuidelines.propTypes = {
    product: PropTypes.string,
};

export default FindGuidelines;
